import React, { useState, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { Typography, Box, Skeleton, Snackbar, Alert } from '@mui/material'
import Error from '../Error'
// import usePageTracking from '../../services/usePageTracking'
import TaxTreatyArticle from './TaxTreatyArticle'
import { fetchTaxTreatyBySlug } from '../../services/articleAPISevicesUsingFetch'

const TaxTreatyDetail = () => {
  // usePageTracking()

  const { slug } = useParams()
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('') // Feedback submitted successfully
  const [snackbarSeverity, setSnackbarSeverity] = useState('success') // success or error
  const handleSnackbarClose = useCallback((event, reason) => {
    if (reason === 'clickaway') return
    setSnackbarOpen(false)
  }, [])

  const showSnackbar = useCallback((message, severity) => {
    setSnackbarMessage(message)
    setSnackbarSeverity(severity)
    setSnackbarOpen(true)
  }, [])
  // const [treaty, setTreaty] = useState(null)
  // const [error, setError] = useState(null)
  // const [loading, setLoading] = useState(true)
  // const baseUrl = process.env.REACT_APP_BACKEND_URL

  // useEffect(() => {
  //   const fetchTreaty = async () => {
  //     try {
  //       const data = await fetchTaxTreatyBySlug(slug)
  //       setTreaty(data)
  //     } catch (error) {
  //       console.error('Failed to fetch tax treaty:', error)
  //       setError(error)
  //     } finally {
  //       setLoading(false)
  //     }
  //   }

  //   fetchTreaty()
  // }, [slug])

  // if (loading) {
  //   return (
  //     <Box sx={{ padding: 2 }}>
  //       <Skeleton variant='text' width='80%' height={40} />
  //       <Skeleton
  //         variant='text'
  //         width='60%'
  //         height={30}
  //         sx={{ marginTop: 2 }}
  //       />
  //       <Skeleton
  //         variant='rectangular'
  //         width='100%'
  //         height={400}
  //         sx={{ marginTop: 2 }}
  //       />
  //     </Box>
  //   )
  // }

  // if (error) {
  //   return <Error error={error} />
  // }

  // return treaty && <TaxTreatyArticle treaty={treaty} />
  return (
    <>
      <TaxTreatyArticle treaty={{ slug }} showSnackbar={showSnackbar} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1500}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{
            mt: 5.5,
            width: '100%',
            // backgroundColor:
            //   snackbarSeverity === 'warning'
            //     ? '#ffcf51'
            //     : snackbarSeverity === 'error'
            //     ? '#d32f2f'
            //     : snackbarSeverity === 'success'
            //     ? '#43a047'
            //     : '#232536',
            // color: snackbarSeverity === 'warning' ? '#232536' : '#fff',
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  )
}

export default TaxTreatyDetail
